'use strict';

import {Component, Input, EventEmitter, Output} from 'ng-metadata/core';
import {TabsAndScopesSelectorService} from './tabsAndScopesSelector.service';
//your imports go here
import {getSearchScopesMap,updateSearchScopesMap} from '../../../appConfig/appConfigForward';
import {ConfigurationUtil} from "../../../nddUtils/configurationUtil.service";


@Component({
selector: 'prm-tabs-and-scopes-selector',
templateUrl: 'components/search/searchBar/tabsAndScopesSelector/tabs-and-scopes-selector.html',
})


export class PrmTabsAndScopesSelector{
    private searchScopesMap:Object = getSearchScopesMap();
    private _tabOptions: Array<string>;
    private _scopeOptions: Array<string>;
    @Input() selectedTab: string;
    @Input() selectedScope: string;
    @Output() private updateFindInDbEvent = new EventEmitter();
    @Output() private changeTabEvent = new EventEmitter();

    constructor(private tabsAndScopesSelectorService: TabsAndScopesSelectorService,
                private configurationUtil: ConfigurationUtil) {
        this.updateScopes();
        this._tabOptions= Object.keys(this.searchScopesMap);
       
    }

    ngAfterViewInit(){
        this.tab=  this.tab || this._tabOptions[0];
        this._scopeOptions= this.searchScopesMap[this.tab];
        this.tabsAndScopesSelectorService.updateIsRemoteTab(this.tab);
    }

    get scope(){
        return this.selectedScope;
    }

    set scope(scope){
        this.selectedScope= scope;
    }

    get tab(){
        return this.selectedTab;
    }

    set tab(tab){
        this.selectedTab= tab;
    }


    get tabOptions(){
        return this._tabOptions;
    }

    onTabChange(){
        this.scope= this.scopeOptions[0]['scope-id'];
        this.tabsAndScopesSelectorService.updateIsRemoteTab(this.tab);
        this.updateFindInDbEvent.emit(this.tab);
        this.changeTabEvent.emit();
    }

    showScopesSelect() {
        return this.scopeOptions.length>1;
    }

    showTabsSelect() {
        return this.tabOptions.length>1;
    }


    get scopeOptions(){
        return this.searchScopesMap[this.tab];
    }
    
    private updateScopes() {
        if(this.configurationUtil.isSuprima()){
            return;
        }
        this.tabsAndScopesSelectorService.updateScopes().then(res => {
           updateSearchScopesMap(res.data);
           this.searchScopesMap = getSearchScopesMap();
        });
    }

}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/searchBar/tabsAndScopesSelector/tabsAndScopesSelector.directive.ts